module.exports = "<div #mapEl class=\"map\"></div>"